import React, { useState } from "react";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";
import {
  setFlagData,
  useSelectFlagData,
} from "../../../../redux/features/flagDetails/flagDetailsSlice";
import { useParams } from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import { Box, Button, Group, Modal, Textarea } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { escalateFlag } from "../../../../services/flag";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

const Escalate = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const flagData = useSelectFlagData();
  const escalatePermission = useCheckPermission("ESCALATE");

  const [opened, { open, close }] = useDisclosure(false);
  const [escalateText, setEscalateText] = useState("");
  const isEscalated = flagData?.flagDetails.status === "ESCALATED";

  const escalateMutation = useMutation({
    mutationKey: ["escalateFlag"],
    mutationFn: (data) => escalateFlag(data),
    onSuccess: async ({ data }) => {
      dispatch(setFlagData(data));
      toast.success("Flag assigned successfully.");
    },
    onError: (err) => {
      toast.error(
        err.response?.data?.message ||
          "An error occurred while assigning the flag.",
      );
    },
  });

  const handleConfirm = async () => {
    await escalateMutation.mutate({ id, text: escalateText });
    close();
  };

  if (escalatePermission && isEscalated) {
    return null; // if no permission to escalate or already escalated, hide the button
  }

  return (
    <Box>
      <Button variant="outline" onClick={open}>
        Escalate
      </Button>
      <Modal opened={opened} onClose={close} title="Escalate" centered>
        <Textarea
          placeholder="Enter escalation details..."
          value={escalateText}
          onChange={(e) => setEscalateText(e.target.value)}
        />
        <Group justify="space-between" position="apart" mt="md">
          <Button variant="outline" color="red" onClick={close}>
            Cancel
          </Button>
          <Button
            loading={escalateMutation.isPending}
            disabled={!escalateText.trim()}
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </Group>
      </Modal>
    </Box>
  );
};

export default Escalate;
